import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5956c2d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap-top" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "top-list help-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "帮助中心"),
  /*#__PURE__*/_createElementVNode("span", null, "提供系统功能、常见问题解答和操作指南等支持与指导。")
], -1))
const _hoisted_5 = { class: "main" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 1.每解锁一次检测报告将消耗一次检测次数，此后再查看已解锁报告将永久免费。 ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 1.①步：填写论文题目和选择文件类型(也可以直接上传文件，系统会为您自动匹配论文题目和文件类型) ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2.②步：选择所属学校", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3.③步：选择模板", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "4.④步：点击“下一步”，选择检测项目", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "5.⑤步：上传检测", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "6.⑥步：检测成功", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 7.⑦步：点击查看检测报告（将跳转“历史记录”获取您的检测报告\"） ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 8.⑧步：点击解锁报告即可查看报告（如遇检测次数不足请前往个人中心充值） ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 1.文品易通会严格遵守保密规定，对所有用户提交的送检文档仅做检测分析，绝不保留全文，承诺对用户送检的文档不做任何形式的收录和泄露 ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 1.若是系统原因检测失败，将会在24个小时内退款，如未收到退款信息，请联系客服。 2.联系客服时，需提供'报告编号' ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 1.正常情况下万字以内的论文，检测耗时1-10分钟以内，检测时间与论文长短及您的网络响应时间有一定关系 ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 感谢您对文品易通的支持与信任。为了确保您在论文格式检测时的顺畅体验，我们注意到近期有部分用户尝试将.doc文件通过直接更改扩展名为.docx的方式进行上传，这可能导致文件格式与扩展名不匹配，引发无法正常识别或处理的问题。 ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 为避免此类情况影响您的正常使用，我们在此为您提供正确的.doc文件转换为.docx格式的操作指南，请务必按照以下步骤操作："),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 1. 打开原始.doc文件：首先，使用Microsoft Word或其他兼容的文档编辑软件（确保其支持.doc和.docx格式），打开您需要上传的.doc文件。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 2.执行“另存为”操作：在打开的文档窗口中，点击菜单栏中的“文件”，选择“另存为”选项。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 3.选择.docx格式：在弹出的“另存为”对话框中，找到并点击“保存类型”或“格式”下拉菜单，从列表中选择“Word Document (.docx)”格式，同时勾选“保留与 Word早期版本的兼容性”选项。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 4.确认保存位置：确保保存路径无误，如有需要，您可以在此时选择或创建合适的文件夹以存放转换后的.docx文件。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 5.点击“保存”：最后，点击“保存”按钮，软件将自动将您的.doc文件转换并保存为.docx格式。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 6.完成上述步骤后，您得到的便是与扩展名相符、且符合平台要求的.docx文件，此时再进行上传操作，即可顺利通过格式验证，确保文件内容准确无误地呈现在平台上。 ")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 我们建议所有用户在上传.docx文件前，均遵循以上方法进行正确转换，以避免因文件格式问题导致的任何不便。如在操作过程中遇到困难或仍有疑问，欢迎您随时联系我们的客服团队，我们将竭诚为您提供协助。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("感谢您的理解与配合，祝您在我们的软件平台上使用愉快！ ")
], -1))

import { ref, reactive, onMounted } from "vue";
import { feedbackSend, uploadImg } from "@/service/helpCenter/request.js";
import type { FormInstance, FormRules } from "element-plus";
import { ElMessage } from "element-plus";
import type { UploadProps, UploadUserFile } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpCenter',
  setup(__props) {

const activeName = ref<any>("first");
const uploadImgRef = ref(); // 上传图片组件
const dialogImageUrl = ref(""); // 预览截图
const dialogVisible = ref(false); // 预览弹窗
const opinionFormRef = ref<FormInstance>(); // 意见反馈表单组件
const pictureList = ref([]); // 上传图片集合

// 意见反馈表单
const opinionForm = reactive({
  imgPath: [],
  problemDesc: "",
});

// 定义意见反馈表单校验规则
const opinionRules = reactive<FormRules>({
  problemDesc: [
    { required: true, message: "问题描述不能为空", trigger: "change" },
  ],
});

// 删除截图
const handleRemove: UploadProps["onRemove"] = (uploadFile, uploadFiles) => {
  pictureList.value = pictureList.value.filter(
    (item) => item.name !== uploadFile.name
  );
};

// 遍历上传图片提取url
const getImgPath = () => {
  pictureList.value.forEach((item) => {
    opinionForm.imgPath.push(item.url);
  });
};

// 预览截图
const handlePictureCardPreview: UploadProps["onPreview"] = (uploadFile) => {
  dialogImageUrl.value = uploadFile.url!;
  dialogVisible.value = true;
};

// 上传截图大小限制
const beforeUpload = (file) => {
  const isSize = file.size / 1024 / 1024 <= 5;
  const isName = file.name.endsWith("png") || file.name.endsWith("jpg");
  if (!isSize) {
    ElMessage.warning("图片大小不能超过5MB!");
    return false;
  }
  if (!isName) {
    ElMessage.warning("请上传格式为png或jpg的截图");
    return false;
  }
};

// 上传截图数量限制
const uploadExceed = (files) => {
  ElMessage.warning("当前限制最多只能上传3张截图");
};

// 上传截图
const handUpload = async (params) => {
  let formData = new FormData();
  formData.append("file", params.file);
  const res = await uploadImg(formData);
  if (res && res.code && res.code == 200) {
    pictureList.value.push(res.data);
  } else {
    ElMessage.error("上传失败");
  }
};

// 提交意见反馈表单
const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      getImgPath();
      let params = {
        imgPath: opinionForm.imgPath.toString(),
        message: opinionForm.problemDesc,
      };
      const res = await feedbackSend(params);
      if (res && res.code && res.code == 200) {
        pictureList.value = [];
        opinionForm.imgPath = [];
        formEl.resetFields();
        uploadImgRef.value.clearFiles();
        ElMessage.success(res.data);
      } else {
        ElMessage.error("提交失败");
      }
    }
  });
};

// 重置意见反馈表单
const resetForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.resetFields();
};

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_card, {
          class: "card",
          shadow: "never"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, {
          shadow: "never",
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((activeName).value = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_tabs, {
                "tab-position": "top",
                modelValue: activeName.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((activeName).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tab_pane, {
                    label: "意见反馈",
                    name: "first"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form, {
                        model: opinionForm,
                        rules: opinionRules,
                        "hide-required-asterisk": "",
                        ref_key: "opinionFormRef",
                        ref: opinionFormRef,
                        size: "large"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "上传截图：",
                            prop: "imgPath"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_upload, {
                                class: "avatar-uploader",
                                action: "#",
                                multiple: "",
                                accept: ".png,.jpg",
                                "list-type": "picture-card",
                                limit: 3,
                                "on-preview": handlePictureCardPreview,
                                "on-remove": handleRemove,
                                "before-upload": beforeUpload,
                                "on-exceed": uploadExceed,
                                "http-request": handUpload,
                                ref_key: "uploadImgRef",
                                ref: uploadImgRef
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Plus)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 512),
                              _createVNode(_component_el_dialog, {
                                modelValue: dialogVisible.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
                                width: "60%",
                                "align-center": "",
                                draggable: ""
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("img", {
                                    class: "screenshot",
                                    src: dialogImageUrl.value,
                                    alt: "Preview Image"
                                  }, null, 8, _hoisted_6)
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "问题描述：",
                            prop: "problemDesc"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: opinionForm.problemDesc,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((opinionForm.problemDesc) = $event)),
                                rows: 6,
                                type: "textarea",
                                maxlength: "200",
                                "show-word-limit": "",
                                placeholder: "请输入问题描述："
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                color: "#0054fe",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (submitForm(opinionFormRef.value)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("提交")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_button, {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (resetForm(opinionFormRef.value)))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("重置")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_tab_pane, {
                    label: "新手指南",
                    name: "second"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_collapse, { accordion: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_collapse_item, { title: "1、如何计费" }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_collapse_item, { title: "2、如何检测" }, {
                            default: _withCtx(() => [
                              _hoisted_8,
                              _hoisted_9,
                              _hoisted_10,
                              _hoisted_11,
                              _hoisted_12,
                              _hoisted_13,
                              _hoisted_14,
                              _hoisted_15
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_tab_pane, {
                    label: "常见问题",
                    name: "third"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_collapse, { accordion: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_collapse_item, { title: "1、我的论文上传之后安全吗？" }, {
                            default: _withCtx(() => [
                              _hoisted_16
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_collapse_item, { title: "2、因系统原因检测失败如何退款？" }, {
                            default: _withCtx(() => [
                              _hoisted_17
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_collapse_item, { title: "3、检测需要多少时间？" }, {
                            default: _withCtx(() => [
                              _hoisted_18
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_collapse_item, { title: "4、关于正确上传.docx文件的方法" }, {
                            default: _withCtx(() => [
                              _hoisted_19,
                              _hoisted_20,
                              _hoisted_21
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})